import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../../UIAssetKeys';

export default class SauceDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);
    this.frame = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._Sauce_1_Top);

    if (this.scene.textures.exists('saucedisplay')) this.scene.textures.remove('saucedisplay');
    this.sauceDisplayCanvas = this.scene.textures.createCanvas('saucedisplay', this.frame.width, this.frame.height);

    this.sprite = this.scene.add.image(0,0,'saucedisplay').setOrigin(0);
    this.add(this.sprite);

    this.currentSauceValue = 1;
  }

  switchSauce (sauceNum) {
    this.currentSauceValue = sauceNum;
    this.frame = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, `Sauce+${sauceNum}+Top`);

    this.sauceDisplayCanvas.setSize(this.frame.width, this.frame.height);
  }

  /**
   * 
   * @param {Phaser.Textures.CanvasTexture} mask 
   */
  updateDisplayCanvas(mask) {
    this.sauceDisplayCanvas.clear();

    const ctx = this.sauceDisplayCanvas.context;
    ctx.globalCompositeOperation = 'source-over';

    // draw the regular frame
    const shape = this.frame.source.image;

    // also need coords of shape image on our Sprite Atlas image so we can copy it to our CanvasTexture
    const coords = this.frame.data.drawImage;

    // using Canvas API to draw shape from DOM Image Element to Canvas 
    ctx.drawImage(shape, coords.x, coords.y, coords.width, coords.height, 0, 0, coords.width, coords.height);

    // "mask" the frame by drawing the mask and using destination in
    ctx.globalCompositeOperation = 'destination-in';

    const globalPos = ABCyaPhaser.GameObjects.getScreenPosition(this.sprite);
    ctx.drawImage(mask.canvas, globalPos.x,globalPos.y, this.sauceDisplayCanvas.width, this.sauceDisplayCanvas.height, 0,0, this.sauceDisplayCanvas.width, this.sauceDisplayCanvas.height);

    this.sauceDisplayCanvas.refresh();
  }
}